'use client'

import { Box, Heading, Text, Icon, VStack } from '@chakra-ui/react'
import { FC } from 'react'
import { IconType } from 'react-icons'

export type BlockCardProps = {
  icon: IconType
  title: string
  description: string
}

export const BlockCard: FC<BlockCardProps> = ({ icon, title, description }) => {
  return (
    <Box
      p={{ base: 6, md: 10 }}
      bg="background.default"
      border="1px solid"
      borderColor="border.default"
      borderRadius="10px"
      textAlign="center"
      transition="all 0.2s ease"
      _hover={{
        borderColor: 'teal.500',
        transform: 'translateY(-2px)'
      }}
    >
      <VStack spacing={2}>
        <Icon as={icon} w={10} h={10} color="teal.500" mb={2} />
        <Heading as="h4" fontWeight={600} fontSize="1rem" fontFamily="body">
          {title}
        </Heading>
        <Text fontSize="0.85rem" color="text.secondary">
          {description}
        </Text>
      </VStack>
    </Box>
  )
}
